export enum EMAIL_LIST_TYPE {
    RESPONSIVE = 'RESPONSIVE',
    CONNECTION = 'CONNECTION',
    ORDER_BOOKING = 'ORDER_BOOKING'
}